export const getAuthorInitials = (author?: string) => {
	if (!author) return '';
	try {
		const localPart = author.split('@')[0];
		const nameParts = localPart.split('+')[0].split('.');
		const firstName = nameParts[0];
		const lastNameInitial = nameParts[1]
			? nameParts[1].charAt(0).toLowerCase()
			: '';
		return `${firstName}.${lastNameInitial}`;
	} catch (error) {
		console.warn(error);
		return;
	}
};

export const getAvatarInitials = (author?: string) => {
	if (!author) return;
	try {
		const nameParts = author.split(/[.@+]/)[0].split(' ');
		return nameParts.map((part) => part.charAt(0).toUpperCase()).join('');
	} catch (error) {
		console.warn(error);
		return;
	}
};
